var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from 'vue-property-decorator';
import _ from "lodash";
import VueDialog from "../../../interface/IVueDialog";
import SupplierOrganService from '../../../api/SupplierOrganService';
import { initClientsRight, formateClientsByGroupTree, createResultByClientsRight, fixBusinessIdsContainGroupNotHasChildren, checkedTempGroupData } from '../../../helper/businessGoodsPriceFunc';
var ApplySuppliersDialog = (function (_super) {
    __extends(ApplySuppliersDialog, _super);
    function ApplySuppliersDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.clients = [];
        _this.clientsRight = [];
        _this.supplier_to_business_ids = [];
        _this.group_ids = [];
        _this.needCheckedIsTemp = false;
        _this.disabled = false;
        _this.requiredChooseNum = true;
        _this.leftKeyword = '';
        _this.rightKeyword = '';
        _this.rightTreeReady = false;
        _this.defaultProps = {
            label: 'business_name',
            id: "supplier_to_business_id"
        };
        return _this;
    }
    ApplySuppliersDialog.prototype.created = function () {
        this.service = SupplierOrganService.getInstance();
    };
    ApplySuppliersDialog.prototype.mounted = function () {
        this.getClients();
    };
    ApplySuppliersDialog.prototype.filterNode = function (value, data) {
        if (!value)
            return true;
        return data.business_name.indexOf(value) !== -1;
    };
    ApplySuppliersDialog.prototype.filterNodeRight = function (value, data) {
        if (data.nodeType == 'business' && !data.isChk) {
            return false;
        }
        if (data.nodeType == 'business_group') {
            if (data.children.length > 0) {
                if (!data.chkChildrensNum) {
                    return false;
                }
            }
            else {
                if (data.is_set_group != 1) {
                    return false;
                }
            }
        }
        if (!value)
            return true;
        return data.business_name.indexOf(value) !== -1;
    };
    ApplySuppliersDialog.prototype.updateClientsRightByBusinessIds = function () {
        this.clientsRight = initClientsRight(this.clientsRight, this.supplier_to_business_ids);
        this.searchRight();
    };
    ApplySuppliersDialog.prototype.updateClientsRightIsSetGroup = function (clientsRight, group_id, checked) {
        clientsRight.forEach(function (v) {
            if (v.group_id == group_id) {
                v.is_set_group = checked ? 1 : 0;
            }
        });
    };
    ApplySuppliersDialog.prototype.handleCheckChange = function (data, checked, indeterminate) {
        if (data.nodeType == 'business_group') {
            this.updateClientsRightIsSetGroup(this.clientsRight, data.group_id, checked);
        }
        this.supplier_to_business_ids = this.$refs.tree.getCheckedKeys(true);
        this.updateClientsRightByBusinessIds();
    };
    ApplySuppliersDialog.prototype.delClient = function (node, data) {
        this.supplier_to_business_ids = this.supplier_to_business_ids.filter(function (id) {
            return id != data.supplier_to_business_id;
        });
        this.updateClientsRightByBusinessIds();
        this.$refs.tree.setCheckedKeys(this.supplier_to_business_ids);
    };
    ApplySuppliersDialog.prototype.changeRightGroupIsSetGroup = function (node, data) {
        if (data.nodeType == 'business_group' && data.children.length == 0 && data.is_set_group != 1) {
            this.supplier_to_business_ids = this.supplier_to_business_ids.filter(function (id) {
                return id != data.supplier_to_business_id;
            });
            this.updateClientsRightByBusinessIds();
            this.$refs.tree.setCheckedKeys(this.supplier_to_business_ids);
        }
    };
    ApplySuppliersDialog.prototype.clearAllClient = function (node, data) {
        this.supplier_to_business_ids = [];
        this.updateClientsRightByBusinessIds();
        this.$refs.tree.setCheckedKeys(this.supplier_to_business_ids);
    };
    ApplySuppliersDialog.prototype.getClients = function () {
        var _this = this;
        this.service.getSuppliersByGroupTree({ is_have_empty_group: 1 }).then(function (res) {
            (res.data.data || []).forEach(function (v) {
                v.group_id = v.category_id;
                v.group_name = v.category_name;
                (v.children || []).forEach(function (v) {
                    v.supplier_to_business_id = v.supplier_upper_id;
                    v.business_name = v.supplier_upper_name;
                });
            });
            res.data.data = formateClientsByGroupTree(res.data.data);
            _this.clients = res.data.data || [];
            if (_this.needCheckedIsTemp) {
                var tempGroupData = checkedTempGroupData(_.cloneDeep(_this.clients));
                _this.supplier_to_business_ids = tempGroupData.supplier_to_business_ids;
                _this.group_ids = tempGroupData.group_ids;
            }
            _this.clientsRight = initClientsRight(_.cloneDeep(_this.clients), _this.supplier_to_business_ids, _this.group_ids);
            _this.supplier_to_business_ids = fixBusinessIdsContainGroupNotHasChildren(_this.clientsRight, _this.supplier_to_business_ids, _this.group_ids);
            setTimeout(function () {
                _this.searchRight();
                _this.rightTreeReady = true;
            }, 300);
        });
    };
    ApplySuppliersDialog.prototype.search = function () {
        this.$refs.tree.filter(this.leftKeyword);
    };
    ApplySuppliersDialog.prototype.searchRight = function () {
        this.$refs.rightTree.filter(this.rightKeyword);
    };
    ApplySuppliersDialog.prototype.close = function () {
        this.$closeDialog();
    };
    ApplySuppliersDialog.prototype.applyData = function () {
        if (this.requiredChooseNum) {
            if (this.supplier_to_business_ids.length == 0) {
                this.$message.warning('请选择供应商');
                return;
            }
        }
        var data = createResultByClientsRight(this.clientsRight);
        this.$emit("submit", data);
        this.close();
    };
    ApplySuppliersDialog = __decorate([
        Component
    ], ApplySuppliersDialog);
    return ApplySuppliersDialog;
}(VueDialog));
export default ApplySuppliersDialog;
